import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TmcYardCommonModule } from '../../common/common.module';
import { ApplicationClientCommonModule,  ServiceResponseModule } from '@sdbn/common';
import { CEPTabletComponent } from './component/cep-tablet.component';
import { CEPProfileTileComponent } from './component/profile-tile/cep-profile-tile.component';
import { TransportDetailsModule } from '../../common/components/transport-details/transport-details.module';
import { CEPCameraTileComponent } from './component/camera-tile/cep-camera-tile.component';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    CEPTabletComponent,
    CEPProfileTileComponent,
    CEPCameraTileComponent
  ],
  exports: [
    CEPTabletComponent
  ],
  imports: [
    CommonModule,

    CommonLayoutModule,
    CommonUIModule,
    ReactiveFormsModule,
    FormsModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    CommonUIModule,
    MatSelectModule
  ]
})
export class CEPTabletModule { }
